import { Command } from "@/lib/command/commands";
import type { Store } from "@/lib/store";
import type { CommandArg, CommandResult } from "@/lib/types";

export class ClearCommand extends Command {
  name = "clear";
  description = "Clear terminal history and localStorage";
  args: CommandArg[] = [];

  execute(args: string[], store: Store): CommandResult {
    if (args.length > 0) {
      return { output: ["clear: unknown argument"], error: true };
    }
    store.terminalClear();
    return { output: ["Terminal cleared"], error: false };
  }
}

export class HelpCommand extends Command {
  name = "help";
  description = "Show available commands";
  args: CommandArg[] = [
    { name: "command", optional: true, description: "Command name" },
  ];

  execute(args: string[], store: Store): CommandResult {
    if (args.length === 0) {
      const lines = ["Available commands:"];
      store.listCommands().forEach((cmd: Command) => {
        lines.push(`  ${cmd.name} - ${cmd.description}`);
      });
      return { output: lines, error: false };
    }

    const commandName = args[0];
    const cmd = store
      .listCommands()
      .find((c: Command) => c.name === commandName);

    if (!cmd) {
      return {
        output: [`help: ${commandName}: command not found`],
        error: true,
      };
    }

    return { output: [`help: ${cmd.getUsage()}`], error: false };
  }
}

export class EchoCommand extends Command {
  name = "echo";
  description = "Echo the provided text";
  args: CommandArg[] = [
    { name: "text", optional: true, description: "Text to echo" },
  ];

  execute(args: string[], _store: Store): CommandResult {
    return { output: [args.join(" ")], error: false };
  }
}
